import axios from "axios";
import i18n from "@/i18n";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

// Tell the server which language the interface is in, so Vale's spoken replies,
// daily quote, Spicy facts and AI lessons come back in the same language.
http.interceptors.request.use((config) => {
  const lang = i18n.resolvedLanguage || i18n.language;
  if (lang) config.headers["Accept-Language"] = lang;
  return config;
});

http.interceptors.response.use(undefined, (error) => {
  if (error?.response?.status === 402 && !window.location.pathname.startsWith("/pricing")) {
    window.location.href = "/pricing";
  }
  return Promise.reject(error);
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  // No reply at all means the network, not Vale, is the problem.
  if (e?.request && !e?.response) return i18n.t("common.offline");
  return i18n.t("common.error");
}

export const todayISO = () => new Date().toLocaleDateString("en-CA");
